module.exports = __webpack_public_path__ + "BradescoSans-Medium-C3JnWfHa.b740a37fb1a459c10602.woff2";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/bradesco/BradescoSans-Medium-C3JnWfHa.woff2
// module id = ../../../../../src/assets/fonts/bradesco/BradescoSans-Medium-C3JnWfHa.woff2
// module chunks = styles